// extracted by mini-css-extract-plugin
export var defaultWrapper = "_m8-3";
export var downloadButton = "_m8-4";
export var fileContainer = "_m8-9 _m8-7";
export var fileContainerBase = "_m8-7";
export var fileContainerFixedHeight = "_m8-8 _m8-7";
export var fileInfo = "_m8-5";
export var fileInfoWidthRestricted = "_m8-6";
export var fileType = "_m8-1";
export var fileTypeName = "_m8-2";
export var image = "_m8-0";
export var link = "_m8-b";
export var overflowEllipsis = "_m8-a";